var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-form-container"},[(_vm.$route.path === '/reset-password')?_c('ResetPassword'):_c('LoginForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }